import { useColors } from "@certn/cascadia-react";
import { getTextStyle } from "@certn/cascadia-react/foundations/typography/styles";
import { CascadiaColor, CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { useMemo } from "react";
import { mergeProps } from "react-aria";
import { Text as AriaText, TextProps } from "react-aria-components";

interface Props extends Omit<TextProps, "style"> {
  style?: CascadiaTypographyStyle;
  color?: CascadiaColor;
}

export function Text(props: Props) {
  const { style, color, ...textProps } = props;

  const colors = useColors();

  const className = useMemo(
    () =>
      css(
        props.style && getTextStyle(props.style),
        props.color && { color: colors[props.color] }
      ),
    [colors]
  );

  if (!props.children) {
    return null;
  }

  if (!props.slot) {
    return (
      <span
        className={css(
          props.style && getTextStyle(props.style),
          props.color && { color: colors[props.color] }
        )}
        {...textProps}
      >
        {props.children}
      </span>
    );
  }

  return <AriaText {...mergeProps(textProps, { className })} />;
}
